class ClampDetect {
    private readonly elements: NodeListOf<HTMLElement>;

    constructor() {
        this.elements = document.querySelectorAll("[data-clamp-detect]") as NodeListOf<HTMLElement>;
        window.addEventListener("resize", this.apply.bind(this));
        this.apply();
    }

    apply(): void {
        this.elements.forEach((element) => {
            element.classList.toggle("line-clamped", element.scrollHeight > element.clientHeight);
        });
    }
}

new ClampDetect();
